var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guide" }, [
    _c(
      "div",
      { staticClass: "preview" },
      [
        _vm.curType == "video"
          ? _c(
              "video",
              {
                ref: "preVideo",
                attrs: {
                  src: _vm.fileObj.ossOriUrl,
                  controls: "controls",
                  controlslist: "nodownload",
                  poster: _vm.imgUrl,
                  playsinline: "",
                  "webkit-playsinline": "true",
                  preload: "metadata",
                  autoplay: false,
                },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("a", { attrs: { href: "https://www.google.cn/chrome/" } }, [
                  _vm._v("点击这里下载浏览器"),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.curType == "flash"
          ? _c("div", [
              _c("embed", {
                attrs: {
                  src: _vm.fileObj.ossOriUrl,
                  width: "760",
                  height: "400",
                },
              }),
              _vm._v(" "),
              _c("h2", [_vm._v("很抱歉，flash动画插件已于2022年停止服务")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.curType == "flv"
          ? _c(
              "div",
              [
                _c("assembly-flv", {
                  attrs: { height: "400px", url: _vm.fileObj.ossOriUrl },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.curType == "audio"
          ? _c("audio", { attrs: { controls: "controls" } }, [
              _c("source", {
                attrs: { src: _vm.fileObj.ossOriUrl, type: "audio/mpeg" },
              }),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("a", { attrs: { href: "https://www.google.cn/chrome/" } }, [
                _vm._v("点击这里下载浏览器"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.curType == "office"
          ? _c(
              "div",
              [
                _vm.photoList.length > 0
                  ? _vm._l(_vm.photoList, function (i, j) {
                      return _c("img", {
                        key: j,
                        staticClass: "officeImg",
                        attrs: { src: i },
                      })
                    })
                  : _vm.officePreviewUrl
                  ? [
                      _c("iframe", {
                        attrs: {
                          src: _vm.officePreviewUrl,
                          frameborder: "0",
                          width: "100%",
                          height: "600px",
                          allowfullscreen: "",
                        },
                      }),
                    ]
                  : _c(
                      "div",
                      { staticClass: "officeTip" },
                      [
                        _c("p", [_vm._v("该文件无法在线预览，请下载后查看")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.download },
                          },
                          [_vm._v("下载文件")]
                        ),
                      ],
                      1
                    ),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.curType == "pic"
          ? _c("el-image", {
              staticStyle: { "max-width": "100%" },
              attrs: {
                src: _vm.fileObj.ossOriUrl,
                "preview-src-list": _vm.srcList,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("很抱歉，您的浏览器"),
      _c("strong", [_vm._v("不支持video播放")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("我们很抱歉，您的浏览器"),
      _c("strong", [_vm._v("不支持audio播放")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }